import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../../Common/AdminBreadcrumb';
import { CreateCorporate as CreateCorporateAPI, EditCorporate } from '../../../../API/admin'
import { useNavigate } from "react-router-dom"
import { useSnackbar } from 'notistack';
import {
    CCard,
    CCardBody,
} from '@coreui/react'

const CreateCorporates = () => {
    // Manage AdminBreadcrumb
    const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;

    const adminBreadcrumbLinks = [
        { label: 'Dashboard', to: '/admin/dashboard', active: false },
        { label: 'Teams', to: '/teams', active: false },
        { label: 'Edit', to: '/tournament/create', active: true }
    ];

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        var urlid = {
            data: urlParams.get('id')
        }
        let callAPI = async () => {
            let res = await EditCorporate(urlid);
            if (res.status) {
                setFormData(res.data);
                const previews = ` ${IMAGE_URL}/teams/${res.data.logo}`;
                setImagePreviews(previews)
            }
        }
        if (urlid) {
            callAPI();
        }
    }, [])

    const [formData, setFormData] = useState({
        name: '',
        domain: '',
        city: '',
        id: '',
        image: null  // New field for image
    });
    const [imagePreviews, setImagePreviews] = useState([]);

    const [errors, setErrors] = useState({
        name: '',
        domain: '',
    });

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });

        setErrors({
            ...errors,
            [name]: ''
        });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];  // Capture the uploaded image file

        // Generate image previews
        const previews = URL.createObjectURL(file);
        setFormData({
            ...formData,
            image: file  // Update the image field in formData
        });
        setImagePreviews(previews);
    };

    const HandelSubmit = async (e) => {
        e.preventDefault();
        let newErrors = {};

        if (formData.domain.trim() === '') {
            newErrors.domain = 'Domain is required';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
        } else {
            const formDataToSend = new FormData();
            formDataToSend.append('name', formData.name);
            formDataToSend.append('domain', formData.domain);
            formDataToSend.append('city', formData.city);
            formDataToSend.append('id', formData.id);

            if (formData.image) {
                formDataToSend.append('logo', formData.image);  // Append the image file if it exists
            }

            let res = await CreateCorporateAPI(formDataToSend);
            if (res.status) {
                enqueueSnackbar('Data saved successfully', {
                    variant: 'success', action: (key) => (
                        <button className='toast_close_btn'
                            onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                            }}
                        >
                            X
                        </button>
                    ),
                });
                navigate('/teams');
            } else {
                enqueueSnackbar(res.data.message, {
                    variant: 'error', action: (key) => (
                        <button className='toast_close_btn'
                            onClick={() => {
                                // Close the Snackbar
                                closeSnackbar(key);
                            }}
                        >
                            X
                        </button>
                    ),
                });
            }
        }
    };

    return (
        <>
            <h4 className="card-title mb-3 align-items-center">
                Create a Team
            </h4>
            <AdminBreadcrumb links={adminBreadcrumbLinks} />
            <CCard className="mb-4">
                <CCardBody>
                    <div className="row justify-content-center">
                        <div className="col-md-7">
                            <form onSubmit={HandelSubmit}>
                                <div className="mb-3">
                                    <label className="form-label"> Name </label>
                                    <input type="text" name="domain" value={formData.domain} onChange={handleInputChange} className="form-control" placeholder='Enter team name' required />
                                    {errors.domain && <span className="error text-danger">{errors.domain}</span>}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label"> City </label>
                                    <input type="text" name="city" value={formData.city} onChange={handleInputChange} className="form-control" placeholder='Enter city' required />
                                </div>

                                {/* New input field for image upload */}
                                <div className="mb-3">
                                    <label className="form-label"> Team Logo </label>
                                    <input type="file" name="image" accept="image/*" onChange={handleImageChange} className="form-control" required />
                                </div>
                                <div className="mb-3">

                                    {imagePreviews.length > 0 && (

                                        <>
                                            <label className="form-label">Preview</label>

                                            <div className="image-preview-container d-flex justify-content-center">
                                                <div className="  image-preview">
                                                    <img src={imagePreviews} style={{ width: '100px', height: '100px' }} alt={`Preview`} />
                                                </div>

                                            </div>
                                        </>
                                    )}
                                </div>
                                <button type="submit" className="btn btn-secondary ms-3 float-end" onClick={() => window.history.back()}>
                                    Cancel
                                </button>
                                <button type="submit" className="btn btn-primary float-end">
                                    Save
                                </button>
                            </form>
                        </div>
                    </div>
                </CCardBody>
            </CCard>
        </>
    );
}


export default CreateCorporates